import TouchRipple from './TouchRipple'

export default TouchRipple
